import { render } from "./TwoFactorAuthentication.vue?vue&type=template&id=3eeb5dce"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
script.render = render

export default script